import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import Event from "../top/event";
import SendForm from "../wall/send_form";
import Wall from "../wall/wall";
import Loader from "../loader";
import ModalEnqueteForm from "../modal/enquete_form";
import ModalProfile from "../modal/modal_profile";
import ModalEnquete from "../modal/modal_enquete";
import ModalConfirm from "../modal/modal_confirm";
import ModalLoader from "../modal/modal_loader";
import EnqueteDeleteButton from "./enquete_delete_button";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleId: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    isManager: PropTypes.bool.isRequired,
    isMemberEventCreateEnable: PropTypes.bool.isRequired,
  },
  getInitialState() {
    return {
      walls: [],
      loading: true,
      panelType: "all",
    };
  },
  loadMyCircleWallsFromServer() {
    let panelType = this.state.panelType;
    $.ajax({
      url: "/api/my_circle/walls",
      type: "GET",
      cache: false,
      data: {
        circle_id: this.props.circleId,
        panel_type: panelType,
      },
    })
      .done(
        function(data) {
          this.setState({
            loading: false,
            walls: data.walls,
          });
        }.bind(this)
      )
      .fail(
        function() {
          this.setState({
            loading: false,
          });
        }.bind(this)
      );
  },
  handlePanelTypeBtn(e) {
    this.setState(
      {
        panelType: e.target.value,
      },
      function() {
        this.loadMyCircleWallsFromServer();
      }
    );
  },
  componentDidMount() {
    this.loadMyCircleWallsFromServer();
  },
  deleteEnquete() {
    this.modalLoader.openModal();
    $.ajax({
      type: "DELETE",
      url: "/api/enquete/delete",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        wall_id: this.state.wallId,
      },
    })
      .done(
        function() {
          this.loadMyCircleWallsFromServer();
          this.modalLoader.closeModal();
        }.bind(this)
      )
      .fail(
        function() {
          this.modalLoader.closeModal();
        }.bind(this)
      );
  },
  handleOpenButton(wallId) {
    this.setState({
      wallId: wallId,
    });
    this.modalConfirmOpen.openModal();
  },
  render() {
    const currentUser = this.props.currentUser;
    const isManager = this.props.isManager;
    const isMemberEventCreateEnable = this.props.isMemberEventCreateEnable;
    const handleOpenButton = this.handleOpenButton;
    const walls = this.state.walls.map(
      function(wall) {
        if (wall.event_id) {
          return (
            <div
              className="mb10"
              style={{ background: "#efefef", padding: "10px" }}
              key={"wall" + wall.id}
            >
              <Event event={wall.event} />
              {(wall && (
                <Wall
                  wall={wall}
                  wallsLikeUsers={wall.walls_like_users}
                  currentUser={currentUser}
                  isCommentShow={false}
                  isBodyShow={false}
                />
              )) ||
                ""}
            </div>
          );
        }
        if (wall.enquete_id) {
          return (
            <div
              className="mb10"
              style={{ background: "#efefef", padding: "10px" }}
              key={"wall" + wall.id}
            >
              <div className="flex">
                <ModalProfile currentUserId={currentUser.id} user={wall.user} />
                <EnqueteDeleteButton
                  wall={wall}
                  currentUser={currentUser}
                  isManager={isManager}
                  handleOpenButton={handleOpenButton}
                />
              </div>
              <ModalEnquete
                enqueteId={wall.enquete_id}
                currentUserId={currentUser.id}
              />
              {(wall && (
                <Wall
                  wallId={wall.id}
                  wall={wall}
                  wallsLikeUsers={wall.walls_like_users}
                  currentUser={currentUser}
                  isCommentShow={false}
                  isBodyShow={false}
                />
              )) ||
                ""}
            </div>
          );
        }
        return (
          <div
            className="mb10"
            style={{ background: "#efefef", padding: "10px" }}
            key={"wall" + wall.id}
          >
            {(wall && (
              <Wall
                wallId={wall.id}
                wall={wall}
                wallsLikeUsers={wall.walls_like_users}
                currentUser={currentUser}
                user={wall.user}
                isCommentShow={false}
                isBodyShow={true}
              />
            )) ||
              ""}
          </div>
        );
      }.bind(this)
    );
    return (
      <div>
        <div className="flex" style={{ padding: "5px" }}>
          {isManager ||
            (isMemberEventCreateEnable && (
              <a
                className="btn btn-info mt10 mr10 mb10 pt10 pb10"
                href={`/events/new/${this.props.circleId}`}
              >
                <span className="color-white">
                  <i className="far fa-calendar-alt" aria-hidden="true" />{" "}
                  イベントをつくる
                </span>
              </a>
            ))}
          <ModalEnqueteForm
            currentUserId={this.props.currentUserId}
            circleId={this.props.circleId}
          />
        </div>
        <SendForm
          currentUser={currentUser}
          loadMyCircleWallsFromServer={this.loadMyCircleWallsFromServer}
          circleId={this.props.circleId}
        />
        <article className="mb20">
          <div className="tab_wrap">
            <div
              className="tab_area sticky"
              style={{ top: "44px", zIndex: "15" }}
            >
              <ul style={{ padding: "0" }}>
                <li>
                  <label
                    className={
                      this.state.panelType === "all" ? "tab-checked" : ""
                    }
                  >
                    <input
                      name="event_type"
                      className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
                      type="radio"
                      checked={this.state.panelType === "all"}
                      onChange={this.handlePanelTypeBtn}
                      value="all"
                    />
                    すべて
                  </label>
                </li>
              </ul>
            </div>
            <div className="panel_area">
              <div className="width-full">
                <Loader isActive={this.state.loading} />
                {walls}
              </div>
            </div>
          </div>
        </article>
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmOpen = c;
          }}
          approveFunc={this.deleteEnquete}
          title="アンケートの削除"
          content="アンケートを削除してもよろしいですか？元に戻すことはできません。"
        />
        <ModalLoader
          ref={(c) => {
            this.modalLoader = c;
          }}
        />
      </div>
    );
  },
});
